var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "evadetail-content" },
    [
      _c(
        "div",
        {
          staticClass: "evadetail",
          class: { "change-evadetail": _vm.changeFlag }
        },
        [
          _c(
            "div",
            { staticClass: "namedate" },
            [
              _c("img", {
                attrs: { src: _vm.productComment.accountAvatar, alt: "" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.productComment.accountNickName))
              ]),
              _vm._v(" "),
              _vm.showRate
                ? _c("van-rate", {
                    attrs: {
                      size: 14,
                      count: _vm.productComment.quantity,
                      color: "#EE2E50",
                      readonly: ""
                    },
                    model: {
                      value: _vm.productComment.quantity,
                      callback: function($$v) {
                        _vm.$set(_vm.productComment, "quantity", $$v)
                      },
                      expression: "productComment.quantity"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { class: ["evaword", { isLimit: _vm.isLimit === true }] }, [
            _vm._v(
              _vm._s(
                _vm.productComment.content
                  ? _vm.productComment.content
                  : "此用户没有填写评价"
              )
            )
          ]),
          _vm._v(" "),
          _vm.imgShow
            ? _c("div", [
                _vm.productComment.commentImage
                  ? _c(
                      "div",
                      { staticClass: "imgs clearfix" },
                      _vm._l(
                        _vm.productComment.commentImage.split(","),
                        function(img, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "imgs1" },
                            [
                              _c("div", {
                                staticClass: "zoomImage",
                                style: { backgroundImage: "url(" + img + ")" },
                                on: {
                                  click: function($event) {
                                    _vm.imgshowFun(index)
                                  }
                                }
                              })
                            ]
                          )
                        }
                      ),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.productComment.replyContent
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "['color', 'reply', {'isLimit': isLimit === true}]"
                      },
                      [
                        _vm._v(
                          "商家回复：" + _vm._s(_vm.productComment.replyContent)
                        )
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "bottom" }, [
            _c("div", { staticClass: "date-type-wrapper" }, [
              _c("span", { staticClass: "date" }, [
                _vm._v(_vm._s(_vm.productComment.commentDate))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "color sku" }, [
              _vm._v(_vm._s(_vm.productComment.specificationValue))
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("van-image-preview", {
        ref: "preview",
        attrs: { images: _vm.images, "start-position": _vm.index },
        on: { change: _vm.onChange },
        model: {
          value: _vm.show,
          callback: function($$v) {
            _vm.show = $$v
          },
          expression: "show"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }